import React from 'react'
import { Link } from '@inertiajs/react'
import UserLayout from '../../../Layouts/UserLayout'

export default function Index({ texts }) {
  return (
    <UserLayout>
      <div className="max-w-5xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Admin: Texts</h1>
          <div className="flex gap-3">
            <Link href="/admin/texts/bulk_generate" className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700">
              Bulk Generator
            </Link>
            <Link href="/admin/texts/new" className="bg-emerald-600 text-white px-4 py-2 rounded hover:bg-emerald-700">
              New Text
            </Link>
          </div>
        </div>
        
        <div className="bg-white shadow rounded overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50 text-left">
                <th className="p-4 border-b">Title</th>
                <th className="p-4 border-b">Topics (Tags)</th>
                <th className="p-4 border-b">Difficulty</th>
                <th className="p-4 border-b">Tokens</th>
                <th className="p-4 border-b text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {texts.map(text => (
                <tr key={text.id} className="border-b last:border-0 hover:bg-gray-50">
                  <td className="p-4">{text.title}</td>
                  <td className="p-4">
                    {text.tags && text.tags.length > 0 ? (
                      <div className="flex flex-wrap gap-1">
                        {text.tags.map(tag => (
                          <span 
                            key={tag.id}
                            className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200"
                          >
                            {tag.name_en || tag.name}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span className="text-gray-400 italic text-sm">No topics</span>
                    )}
                  </td>
                  <td className="p-4">{text.difficulty}</td>
                  <td className="p-4">{text.tokens?.length || 0}</td>
                  <td className="p-4 text-right space-x-2">
                    <Link href={`/admin/texts/${text.id}/edit`} className="text-indigo-600 hover:text-indigo-900 font-medium">Edit</Link>
                    <Link 
                      href={`/admin/texts/${text.id}`} 
                      method="delete" 
                      as="button"
                      className="text-red-600 hover:text-red-900 font-medium ml-4"
                      onClick={e => { if(!confirm('Are you sure?')) e.preventDefault() }}
                    >
                      Delete
                    </Link>
                  </td>
                </tr>
              ))}
              {texts.length === 0 && (
                <tr>
                  <td colSpan="5" className="p-4 text-center text-gray-500">No texts found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </UserLayout>
  )
}

